import TemplateFittingEnum from '@/domains/sole/typescript/enums/TemplateFittingEnum';
import { ZERO_PARAMETER_VALUE } from '@/domains/sole/services/utils/defaultValues';
import type SoleParametersInterface from '@/domains/sole/typescript/interfaces/SoleParametersInterface';

function isInternalArchTemplateFitted(templateFitting: TemplateFittingEnum): boolean {
    return templateFitting === TemplateFittingEnum.Internal || templateFitting === TemplateFittingEnum.Both;
}

function isExternalArchTemplateFitted(templateFitting: TemplateFittingEnum): boolean {
    return templateFitting === TemplateFittingEnum.External || templateFitting === TemplateFittingEnum.Both;
}

function zeroTemplateFittedArches(
    templateFitting: TemplateFittingEnum,
    soleParameters: SoleParametersInterface,
): SoleParametersInterface {
    return {
        ...soleParameters,
        internalArch: isInternalArchTemplateFitted(templateFitting)
            ? ZERO_PARAMETER_VALUE
            : soleParameters.internalArch,
        externalArch: isExternalArchTemplateFitted(templateFitting)
            ? ZERO_PARAMETER_VALUE
            : soleParameters.externalArch,
    };
}

function clampArchToInterArchPoint(
    arch: SoleParametersInterface['internalArch'],
    interArchPoint: SoleParametersInterface['interArchPoint'],
): SoleParametersInterface['internalArch'] {
    const minimumArch = interArchPoint || ZERO_PARAMETER_VALUE;
    return arch && +arch >= +minimumArch ? arch : minimumArch;
}

function clampEditableArches(
    templateFitting: TemplateFittingEnum,
    soleParameters: SoleParametersInterface,
): SoleParametersInterface {
    const { interArchPoint } = soleParameters;
    return {
        ...soleParameters,
        internalArch: isInternalArchTemplateFitted(templateFitting)
            ? soleParameters.internalArch
            : clampArchToInterArchPoint(soleParameters.internalArch, interArchPoint),
        externalArch: isExternalArchTemplateFitted(templateFitting)
            ? soleParameters.externalArch
            : clampArchToInterArchPoint(soleParameters.externalArch, interArchPoint),
    };
}

const TemplateFittingArches = {
    isInternalArchTemplateFitted,
    isExternalArchTemplateFitted,
    zeroTemplateFittedArches,
    clampEditableArches,
};

export { TemplateFittingArches };
